import { defineAgenda, param } from '@/shared/navigation/core';
import i18n from '@/shared/lib/i18n';

/**
 * Agenda detailu placeholderu — jeden formulář pro založení i editaci. Bez `placeholderId` =
 * založení, s `placeholderId` = editace. Otevírá se jako modální vrstva nad knihovnou placeholderů.
 */
export const placeholderDetailAgenda = defineAgenda({
  id: 'app.venua-planner.placeholder-detail',
  path: 'app/venua-planner/placeholder',
  open: {
    placeholderId: param.uuid().optional(),
  },
  title: () => i18n.t('schemes.placeholder.agendaTitle', { ns: 'venua-planner' }),
  icon: 'square-dashed',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
